export namespace AppConstants {
    export const ReferrerPathSegment = 'r';
    export enum LocalStorageKeys {
        jwt = 'jwt',
        HAVE_SET_LANGUAGE = 'have-set-language',
        SIGNUP_EXPORT_COLUMNS = 'signup-export-columns',
    }

    export enum HttpStatusCode {
        Success = 200,
        Unauthorized = 401,
    }
}

export const emailRegex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export const summernoteToolbar = [
    ['font', ['fontsize', 'bold', 'underline', 'clear']],
    ['color', ['color']],
    ['para', ['ul', 'ol', 'paragraph']],
    ['table', ['table']],
    [
        'insert',
        [
            'link',
            'picture',
            /* the width of video iframes breaks the layout 'video' */
        ],
    ],
    ['view', ['codeview', 'help']],
];

export enum EmailTemplateTag {
    FirstName = '{FirstName}',
    LastName = '{LastName}',
    Employer = '{Employer}',
    AuthCardAnswers = '{Answers}',
    LocalNumber = '{LocalNumber}',
    CellPhone = '{CellPhone}', 
    EmailAddress = "{EmailAddress}", 
    Referer = "{Referer}", 
    Region = "{Region}",
    Rating = "{Rating}", 
    Department = "{Department}", 
    Address = "{Address}",
    City = "{City}",
    State = "{State}", 
    Zip = "{Zip}", 
    EmployeeId = "{EmployeeId}", 
    ReasonsForJoining = "{ReasonsForJoining}", 
    Shift = "{Shift}"
}
